export class User {
    getUser() {
        return window.localStorage.getItem('name');
    }

    setUser(name, email, token) {
        window.localStorage.setItem('name', name);
        window.localStorage.setItem('email', email);
        window.localStorage.setItem('token', token);
    }

    logout() {
        window.localStorage.removeItem('name');
        window.localStorage.removeItem('email');
        window.localStorage.removeItem('token');
        location.reload();
    }
}

export function isAuthenticated() {
    const token = window.localStorage.getItem('token');
    if(token) {
        return true;
    }
    return false;
}


// WEBPACK FOOTER //
// ./src/models/User.js